import React from 'react'
import MyPayroll from './MyPayroll'


export default function StudentInformationReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
